<template>
  <table class="table table-striped border-light align-middle">
    <thead>
    <tr>
      <th></th>
      <th class="text-capitalize-first">{{ helper.trans('labels.id_date') }}</th>
      <th class="text-capitalize-first">{{ helper.trans('labels.type')}}</th>
      <th class="text-capitalize-first">{{ helper.trans('labels.status')}}</th>
      <th class="text-capitalize-first">{{ helper.trans('labels.payment_date') }}</th>
      <th class="text-capitalize-first">{{ helper.trans('labels.requisites') }}</th>
      <th class="text-capitalize-first">{{ helper.trans('labels.sum') }}</th>
      <th class="text-capitalize-first">{{ helper.trans('labels.rate') }}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="deal in deals" :key="deal.id">
      <td>
        <PayMethodIcon :method="deal.method"></PayMethodIcon>
      </td>
      <td>
        <div class="d-flex flex-column">
                        <span>
                          <span :title="deal.publicId">{{ deal.publicId }}</span> <copy-button :value="deal.publicId"></copy-button>
                        </span>
          <small class="text-secondary">{{ dateHelper.format(deal.createdAt) }}</small>
        </div>
      </td>
      <td>
        {{ helper.trans(`direction.${deal.type}`) }}
      </td>
      <td :class="{'text-primary': deal.status === DealStatus.TRANSFER_CONFIRMED}">
        {{ helper.trans(`deal_status.${deal.status}`) }}
        <a v-for="attachment in deal.attachments" :key="attachment.id" :href="`${api.baseUrl()}/attachments/${attachment.file}`" target="_blank" type="button" class="me-2 text-warning"><i class="fa fa-paperclip"></i></a>
      </td>
      <td>
        {{ deal.paymentAt ? dateHelper.format(deal.paymentAt) : 'n/a' }}
      </td>
      <td>
        <template v-if="deal.requisite">
          <div>
            <a v-if="deal.requisite.startsWith('http')"
               :href="deal.requisite"
               target="_blank">{{ helper.domain(deal.requisite) }}</a>
            <template v-else>{{ deal.requisite }}</template>
            <copy-button :value="deal.requisite"></copy-button>
          </div>
          <small v-if="deal.holder" class="text-secondary">{{ deal.holder }}</small>
        </template>
        <span v-else class="text-muted">—</span>
      </td>
      <td>{{ deal.takerSum ? numberFormatter.formatMoney(deal.takerSum) : 'n/a' }} / {{ deal.makerSum ? numberFormatter.formatMoney(deal.makerSum) : 'n/a' }}</td>
      <td>{{ deal.rate }}</td>
    </tr>
    </tbody>
  </table>
</template>

<script lang="ts">

import {defineComponent, PropType, Prop} from 'vue'
import {helper} from "@/service/CommonHelper";
import APIClient from "@/service/APIClient";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/components/CopyButton.vue";
import {DealStatus} from "@/models/enum/DealStatus";
import InvoiceDealDTO from "@/models/InvoiceDealDTO";
import {Direction} from "@/models/enum/Direction";
import PayMethodIcon from "@/components/PayMethodIcon.vue";

const api = new APIClient();

export default defineComponent({
  components: {
    PayMethodIcon,
    CopyButton
  },
  props: {
    deals: {
      type: Object as PropType<InvoiceDealDTO[]>,
      default: null
    } as Prop<InvoiceDealDTO[]>
  },
  setup() {
    return {
      dateHelper,
      numberFormatter,
      DealStatus,
      helper,
      Direction,
      api
    }
  }
})
</script>
